<div class="registration-container">


  <div class="form-container">
    <button type="button" class="close-modal-btn" (click)="onCancel()">&times;</button>
    <div class="form-header">Enter the details for Registering Utility with Hygge Energy.</div>
    <form [formGroup]="utilityForm" (ngSubmit)="onSubmit()">
      <div class="upload-logo-container">
        <label for="utilityLogo" class="upload-logo-label">
          <img [src]="logoPreviewUrl || 'assets/utility_logo.png'" alt="Upload Utility Logo" class="utility-logo-image">
          <div class="upload-icon">
            <i class="material-icons">edit</i>
          </div>
        </label>
        <input type="file" id="utilityLogo" class="upload-logo-input" (change)="onFileSelected($event)">
        <p class="upload-logo-text">Upload Utility logo</p>
      </div>

      <div class="form-grid">
        <div class="form-field">
          <label for="utilityName">Utility Name</label>
          <input type="text" id="utilityName" class="form-control" formControlName="utilityName"
            appInputRestriction="alphabetic">
          <div *ngIf="utilityName?.invalid && (utilityName?.dirty || submitted)" class="error">
            <div *ngIf="utilityName?.errors?.['required']">Utility Name is required.</div>
            <div *ngIf="utilityName?.errors?.['pattern']">Alphabets and spaces only</div>
          </div>
        </div>

        <div class="form-field">
          <label for="description">Description</label>
          <input type="text" id="description" class="form-control" formControlName="description"
            appInputRestriction="alphabetic">
          <div *ngIf="description?.invalid && (description?.dirty || submitted)" class="error">
            <div *ngIf="description?.errors?.['pattern']">Alphabets and spaces only</div>
          </div>
        </div>

        <div class="form-field">
          <label for="email">E-mail</label>
          <input type="email" id="email" class="form-control" formControlName="email">
          <div *ngIf="email?.invalid && (email?.dirty || submitted)" class="error">
            <div *ngIf="email?.errors?.['required']">Email address is required.</div>
            <div *ngIf="email?.errors?.['email']">Invalid email format</div>
          </div>
        </div>

        <div class="form-field">
          <label for="enterState">Enter State</label>
          <select id="enterState" class="form-control" formControlName="enterState">
            <option value="" disabled selected>Select State</option>
            <option class="f-option" *ngFor="let state of states" [value]="state.id">{{ state.name }}</option>
          </select>
          <div *ngIf="enterState?.invalid && (enterState?.dirty || submitted)" class="error">
            <div *ngIf="enterState?.errors?.['required']">State is required.</div>
          </div>
        </div>

        <div class="form-field">
          <label for="phoneNumber">Phone Number</label>
          <input type="tel" id="phoneNumber" class="form-control" formControlName="phoneNumber" maxlength="10"
            minlength="10" appInputRestriction="numeric">
          <div *ngIf="phoneNumber?.invalid && (phoneNumber?.dirty || submitted)" class="error">
            <div *ngIf="phoneNumber?.errors?.['required']">Phone number is required.</div>
            <div *ngIf="phoneNumber?.errors?.['pattern']">Phone number must be 10 digits</div>
          </div>
        </div>

        <div class="form-field">
          <label for="enterLocality">Enter Locality / Area Name</label>
          <input type="text" id="enterLocality" class="form-control" formControlName="enterLocality"
            appInputRestriction="alphanumeric">
          <div *ngIf="enterLocality?.invalid && (enterLocality?.dirty || submitted)" class="error">
            <div *ngIf="enterLocality?.errors?.['pattern']">Locality can contain only letters and numbers</div>
          </div>
        </div>

        <div class="form-field">
          <label for="selectStatus">Select Status</label>
          <div class="status-field" (click)="openStatusDialog()">
            <div class="status-display">
              <span *ngIf="statusControl?.value" class="status-badge"
                [ngClass]="{'active-badge': statusControl?.value === 'Active', 'retired-badge': statusControl?.value === 'Retired'}">
                {{ statusControl?.value }}
              </span>
              <span *ngIf="!statusControl?.value">Select Status</span>
            </div>
            <span class="dropdown-arrow">▼</span>
          </div>
          <div *ngIf="statusControl?.invalid && (statusControl?.dirty || submitted)" class="error">
            <div *ngIf="statusControl?.errors?.['required']">Status is required.</div>
          </div>
        </div>

        <div class="form-field">
          <label for="enterPincode">Enter Pincode</label>
          <input type="text" id="enterPincode" class="form-control" formControlName="enterPincode" maxlength="6"
            minlength="6" appPinCode>
          <div *ngIf="enterPincode?.invalid && (enterPincode?.dirty || submitted)" class="error">
            <div *ngIf="enterPincode?.errors?.['required']">Pincode is required.</div>
            <div *ngIf="enterPincode?.errors?.['pattern'] || enterPincode?.errors?.['minlength']">Pincode must be 6
              digits</div>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="cancel-button" (click)="onCancel()">Cancel</button>
        <button type="submit" class="submit-button" [disabled]="!utilityForm.valid">Submit</button>
      </div>
    </form>
  </div>
</div>